import { makeStyles } from '@material-ui/core';
import { KS_PURPLE } from '../theme/ksDigitalTheme';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

/** KS Digital-symbolet alene, brukt når sidepanelet er lukket. */
export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="80.5 80.5 241.6 241.6"
      role="img"
      aria-label="KS Digital"
    >
      <path
        fill={KS_PURPLE}
        d="M241.6,161.1h80.5v80.5h-80.5v-80.5ZM80.5,161.1c0,44.5,36.1,80.5,80.5,80.5v-80.5s-80.5,0-80.5,0h0M161.1,322.1c44.5,0,80.5-36.1,80.5-80.5h-80.5v80.5M241.6,80.5c-44.5,0-80.5,36.1-80.5,80.5h80.5v-80.5"
      />
    </svg>
  );
};
